import type { FC, ReactNode } from 'react'
import type { PaymentMethod } from '@/types'

import {
    Banknote,
    CreditCard,
    Smartphone,
    Wallet
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { PAYMENT_METHODS } from '@/constants/carwash'

export const PAYMENT_ICONS: Record<PaymentMethod, ReactNode> = {
    cash: <Banknote aria-hidden='true' />,
    upi: <Smartphone aria-hidden='true' />,
    card: <CreditCard aria-hidden='true' />,
    other: <Wallet aria-hidden='true' />
}

interface PaymentMethodPickerProps {
    value: PaymentMethod
    onChange: (value: PaymentMethod) => void
    className?: string
}

export const PaymentMethodPicker: FC<PaymentMethodPickerProps> = ({ value, onChange, className }): ReactNode => {
    return (
        <div role='radiogroup' aria-label='Payment method' className={cn('grid grid-cols-4 gap-2', className)}>
            {PAYMENT_METHODS.map(method => {
                const active = method.value === value

                return (
                    <button
                        key={method.value}
                        type='button'
                        role='radio'
                        aria-checked={active}
                        onClick={() => onChange(method.value)}
                        className={cn(
                            'flex h-[72px] flex-col items-center justify-center gap-1.5 rounded-xl border text-[13px] font-semibold transition-[background-color,border-color,box-shadow] focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none [&_svg]:size-6',
                            active
                                ? 'border-primary bg-accent text-accent-foreground shadow-[0_0_0_1px_var(--color-primary)]'
                                : 'border-border bg-card text-slate-700 hover:bg-slate-50'
                        )}
                    >
                        {PAYMENT_ICONS[method.value]}
                        {method.label}
                    </button>
                )
            })}
        </div>
    )
}
